import Pristine from 'pristinejs';
import { statusDialog } from './statusDialog';
import { defaultPristineConfig } from './formControl';

function init(form) {
  const pristine = new Pristine(form, defaultPristineConfig);

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (pristine.validate()) {
      statusDialog().show();
    }
  });
}

export function messageForm() {
  document.querySelectorAll('.message-form').forEach((form) => init(form));
}
